var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1953,
    cy: 12.6094,
    r: 12.5,
    fill: "#E6F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1953 15.6094L9.44531 11.8594L10.4953 10.7719L12.4453 12.7219V6.60938H13.9453V12.7219L15.8953 10.7719L16.9453 11.8594L13.1953 15.6094ZM8.69531 18.6094C8.28281 18.6094 7.92969 18.4625 7.63594 18.1688C7.34219 17.875 7.19531 17.5219 7.19531 17.1094V14.8594H8.69531V17.1094H17.6953V14.8594H19.1953V17.1094C19.1953 17.5219 19.0484 17.875 18.7547 18.1688C18.4609 18.4625 18.1078 18.6094 17.6953 18.6094H8.69531Z",
    fill: "#007FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.d99b07891e7093e9d68764762fcc7643.svg";
export { ForwardRef as ReactComponent };